class VwHastaservisListeDTO {
    id: number = null;
    tip?: number = null;
    giristip?: number = null;
    kimlikId?: number = null;
    muracaatId?: number = null;
    servisId?: number = null;
    doktorId?: number = null;
    asistanId?: number = null;
    hemsireId?: number = null;
    yil?: number = null;
    protokolId?: number = null;
    tarih?: string = null;
    servissira?: number = null;
    doktorsira?: number = null;
    islemdurum?: number = null;
    giristarih?: string = null;
    cikistarih?: string = null;
    cikisyerId?: number = null;
    cikisaciklama?: string = "";
    yatakId?: number = null;
    iptal?: string = "(H)";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    boy?: number = null;
    kilo?: number = null;
    girisKullanici?: number = null;
    aciklama?: string = "";
    nakilServisId?: number = null;
    nakilDoktorId?: number = null;
    nakilGeldigiId?: number = null;
    kontrolhastaservisId?: number = null;
    hastaYas?: number = null;
    adiSoyadi?: string = "";
    kimlikNo?: string = "";
    servis?: string = "";
    organizasyonId?: number = null;
    fkServistip?: number = null;
    oncelikId?: number = null;
    kayitTurId?: number = null;
    cinsiyetId?: number = null;
    kalantoplam?: number = null;
    borcVarKabulYok?: string = "";
    adi?: string = "";
    doktor?: string = "";
    aileAdi?: string = "";
    soyadi?: string = "";
    sevkliHasta?: string = "";
    sevkNo?: string = "";
    sevkTarihi?: string = null;
    sigortaKurumId?: number = null;
    hastaliktanimId?: number = null;
    hastaliktanimtaniId?: number = null;
    searchText?: string = "";

    // Önceden yazılmışlar
    doktorAd?: string = "";
    bagliOrganizasyonId?: number = null;
    fkHbsBransId?: number = null;
}
export default VwHastaservisListeDTO;